import { USER_INITIAL_STATE } from './chunk-HJ42I75R.mjs';

// src/helpers/users/users.ts
var getUserWithMatchingPinCore = (pinValue, state) => {
  const usersObj = state.settings.selectedMode.currentSettings.users;
  let matchedUserPinObj = USER_INITIAL_STATE;
  let pinMatched = false;
  for (const user of Object.entries(usersObj)) {
    if (user[1].pin === pinValue) {
      matchedUserPinObj = user[1];
      pinMatched = true;
      break;
    }
  }
  return { pinMatched, user: matchedUserPinObj };
};
var getUserRolesFromRolesIdsCore = (rolesIds, state) => {
  const roles = state.settings.selectedMode.currentSettings.roles;
  const userRoles = [];
  for (const roleId of rolesIds)
    userRoles.push(roles[roleId]);
  return userRoles;
};
var checkPinAndRegisterPermissionValueCore = (pinValue, permissionKeys, state, allowedOrganizationUserIds, validateFunction) => {
  const { pinMatched, user } = getUserWithMatchingPinCore(pinValue, state);
  if (allowedOrganizationUserIds && allowedOrganizationUserIds.includes(user.organizationUserId)) {
    return true;
  }
  if (!pinMatched)
    return false;
  if (validateFunction)
    return validateFunction(user);
  const permissions = state.settings.location.roles;
  const userRoleIds = user.roleIds;
  const isAllowed = userRoleIds.some(
    (userRoleId) => Object.entries(permissions[userRoleId].registerPermissions).reduce(
      (acc, [permissionKey, value]) => {
        return permissionKeys.includes(permissionKey) && value ? acc + 1 : acc;
      },
      0
    ) === permissionKeys.length
  );
  if (!isAllowed)
    return false;
  else
    return true;
};
var checkPinAndEndOfDayPermissionValueCore = (pinValue, isClockoutScreen, state, allowedOrganizationUserIds, validateFunction) => {
  const { pinMatched, user } = getUserWithMatchingPinCore(pinValue, state);
  if (allowedOrganizationUserIds && allowedOrganizationUserIds.includes(user.organizationUserId)) {
    return true;
  }
  if (!pinMatched)
    return false;
  if (validateFunction)
    return validateFunction(user);
  const permissions = state.settings.location.roles;
  const userRoleIds = user.roleIds;
  const isAllowed = userRoleIds.some((userRoleId) => {
    const vssValue = permissions[userRoleId].endOfDayPermissions.viewShiftSummary;
    return vssValue === "always" /* ALWAYS */ || isClockoutScreen && vssValue === "onClockout" /* ON_CLOCKOUT */;
  });
  if (!isAllowed)
    return false;
  else
    return true;
};

export { checkPinAndEndOfDayPermissionValueCore, checkPinAndRegisterPermissionValueCore, getUserRolesFromRolesIdsCore, getUserWithMatchingPinCore };
